import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "./base-service";
import {AppConfig} from "../config/appconfig";
import {Observable} from "rxjs";
import {TachoData} from "../app/tacho-data";

import { Storage } from '@ionic/storage';
import {dddFile} from "../models/dddFile";
import { analyzeAndValidateNgModules } from '@angular/compiler';

/*
  Generated class for the MonitoringObject provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/

// AS: этот провайдер обеспечивает доступ к объектам мониторинга
// AS: начнем с транспортных средств. Но вообще объектами мониторинга могут быть не только ТС
// AS: поэтому этот провайдер называется не VehicleService, а MonitoringObjectService

@Injectable()
export class MonitoringObjectService extends BaseService {

  public readonly objectGroupsUrl: string = AppConfig.apiBaseUrl + "VehicleGroups";

  public readonly objectsUrl: string = AppConfig.apiBaseUrl + "Vehicles";

  public readonly deviceTypesUrl: string = AppConfig.apiBaseUrl + "DeviceTypes";

  public readonly zonePassagesUrl: string = this.objectsUrl + "/zonepassages"

  public readonly tachoFilesUrl : string = AppConfig.apiBaseUrl + "TachoFiles";

  private readonly tachoFileUrl : string = AppConfig.apiBaseUrl + "tachoFileDownload";

  private readonly tachoXmlFileUrl : string = AppConfig.apiBaseUrl + "tachoXmlDownload";

  private readonly messagesCategoriesUrl: string = AppConfig.apiBaseUrl + "Vehicles/messagesCategories";

  private readonly sendMessageUrl: string = AppConfig.apiBaseUrl + "Vehicles/sendMessage";

  private readonly getMessagesUrl: string = AppConfig.apiBaseUrl + "Vehicles/messages";

  constructor(
    public http: Http,
    protected storage: Storage
  ) {
    super(http, storage);
  }
  public getMessagesCategories(vehicleId: number) : Observable<dddFile[]>{
    let url = this.messagesCategoriesUrl + "/" + vehicleId;
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let r = this.prepareData(res);
        return r.Data;
      });
  }

  public getMessages(vehicleId: number) : Observable<any>{
    const url = this.getMessagesUrl + "/" + vehicleId;
    return this.http.get(
      url,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let r = this.prepareData(res);
        return r;
      });
  }

  public sendTextMessage(object: any) : Observable<any>{
    let action = this.http.post(
      this.sendMessageUrl,
      object,
      {headers: this.headers}
    );

    return action.map((res: Response) => {
      return this.prepareData(res);
    });
  }

  public getDddFiles(vehicleId: number) : Observable<dddFile[]>{
    let url = this.tachoFilesUrl + "/" + vehicleId;
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let r = this.prepareData(res);
        return r.data;
      });
  }

  public LoadTachoFile(fileInfo: dddFile) : Observable<Response>{
    let url = this.tachoFileUrl + "/" + fileInfo.FileId;

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return res;
      });
  }

  public LoadXmlTachoFile(fileInfo: dddFile) : Observable<Response>{
    let url = this.tachoXmlFileUrl + "/" + fileInfo.FileId;

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return res;
      });
  }

  public getGroups(filter): Observable<any[]>{
    let url = this.objectGroupsUrl + (filter ? ("/" + filter) : "");
    return this.http.get(url, {headers: this.headers})
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });

    // return Observable.create((observer) => {
    //
    //   this.getAsyncHeaders()
    //     .then(headers => {
    //       let url = this.objectGroupsUrl + (filter ? ("/" + filter) : "");
    //       let getgroups = this.http.get(
    //         url,
    //         {headers: headers}
    //       )
    //         .map((res:Response) =>
    //         {
    //           let body = res.json();
    //           var d = body || {};
    //           return d;
    //         })
    //         //.catch(this.handleError);
    //
    //       getgroups.subscribe((g) => {
    //         try {
    //           this.storage.set('objectGroups', g);
    //           observer.next(g);
    //           observer.complete();
    //         }catch(err){
    //           throw Observable.throw(err);
    //         }
    //         },
    //         (err) => {
    //           console.log(err);
    //
    //           try {
    //             this.storage.get('objectGroups')
    //               .then((data) => {
    //                 let groups = data;
    //                 observer.next(groups);
    //                 observer.complete();
    //                 return;
    //               })
    //               .catch(e => {
    //                 console.log(e);
    //                 return Observable.throw(e);
    //               });
    //           }
    //           catch(err){
    //             throw Observable.throw(err);
    //           }
    //         }
    //       );
    //     });
    //     // .catch(err => {
    //     //   Observable.throw(err);
    //     // });
    // });
  }

  public getGroupObjects(filter): Observable<any[]>{
    return Observable.create((observer) => {

      this.getAsyncHeaders()
        .then(headers => {
          let url = this.objectGroupsUrl + (filter ? ("/" + filter) : "");
          return this.http.get(
            url,
            {headers: this.headers}
          )
            .map((res: Response) => {
              observer.next(this.prepareData(res));
              observer.complete();
              return;
            });
            //.catch(this.handleError);
        })
        .catch(err => {
          Observable.throw(err);
        })
      ;
    });
  }

  public editGroup(group: any): Observable<any>{
    if(group == null){
      return new Observable<any>(observer => {
        observer.error(new Error("Не передана группа"));
      });
    }

    console.log(group);

    let action: Observable<Response>;

    if(group.id !== undefined && group.id !== null && group.id >= 0){
      // AS: редактируем группу
      action = this.http.put(
        this.objectGroupsUrl,
        group,
        {headers: this.headers}
      );
    }else{
      // AS: создаем группу
      action = this.http.post(
        this.objectGroupsUrl,
        group,
        {headers: this.headers}
      );
    }

    return action.map((res: Response) => {
      return this.prepareData(res);
    });//.catch(this.handleError);
  }

  public removeGroup(id: number): Observable<any>{
    if(id === null || id === undefined){
      return new Observable<any>(observer => {
        observer.error(new Error("Не передана группа"));
      });
    }

    let url = this.objectGroupsUrl + '/' + id;
    return this.http.delete(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return res;
      });
    //.catch(this.handleError);
  }

  // AS: получим список типов устройств (типов контроллеров)
  public getDeviceTypes(): Observable<any[]>{
    let url = this.deviceTypesUrl;
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return this.prepareData(res);
      });
      //.catch(this.handleError);
  }

  // AS: работа с объектами (ТС)
  // AS: Добавление нового ТС
  public editObject(object: any): Observable<any>{
    if(object === null || object === undefined){
      return new Observable<any>(observer => {
        observer.error(new Error("Не передан объект"));
      });
    }

    let action: Observable<Response>;

    let id: number;
    if(object.VehicleId !== undefined && object.VehicleId !== null){
      id = Number(object.VehicleId);
    }
    if(id !== undefined && id !== null && id > 0){
      // AS: редактируем объект
      action = this.http.put(
        this.objectsUrl + "/" + id,
        object,
        {headers: this.headers}
      );
    }else{
      // AS: создаем объект
      action = this.http.post(
        this.objectsUrl,
        object,
        {headers: this.headers}
      );
    }

    return action.map((res: Response) => {
      return this.prepareData(res);
    });
      // .catch((err) =>{
      //   return Observable.throw(err);
      // }
      //this.handleError
    //);
  }

  public removeObject(id: number): Observable<any>{
    if(id === null || id === undefined){
      return new Observable<any>(observer => {
        observer.error(new Error("Не указано ТС"));
      });
    }

    return this.http.delete(
      this.objectsUrl + "/" + id,
      {headers: this.headers}
      ).map((res: Response) => {
        return res;
    })
  }

  // AS: Получение информации об объекте мониторинга
  public getInfo(id: number): Observable<any>{
    let url = this.objectsUrl + "/" + id;
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return this.prepareData(res);
      });
      //.catch(this.handleError);
  }

  // AS: Получение изображения объекта мониторинга (фото ТС)
  public getImage(id: number): Observable<string>{
    let url = this.objectsUrl + "/" + id.toString() + "/image";
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return this.prepareData(res);
      });
      //.catch(this.handleError);
  }

  public  getZonePassages(zoneId: number, from: Date, to: Date) : any{
    let url = this.zonePassagesUrl + "/" + zoneId + "/" +
    from.valueOf() + "/" + to.valueOf() ;
    
      return new Promise(resolve => {
        this.http.get(url, { headers: this.headers }).
        subscribe(
          data => {
            resolve(JSON.parse(data["_body"]));
          },
          error => {
            console.log(error);
          }
        );
      });
  }
  public getSensors(id: number, vehicleId: number): any{
    let url = this.objectsUrl + "/" + id.toString() + "/" + vehicleId.toString() + "/sensors";
    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        return this.prepareData(res);
      });
      //.catch(this.handleError);
  }

  public getImageUrl(id: number): string{
    return this.objectsUrl + "/" + id.toString() + "/image";
  }

  // AS: получение всех ТС (для отображения на карте)
  public getPositions(
    time: number = null,
    filter: string = null,
    latnw: number = null,
    lngnw: number = null,
    latse: number = null,
    lngse: number = null
  ): Observable<any[]>{

    return Observable.create((observer) => {
      let url = this.objectsUrl + "/positions/" + (time || "0");
      // + "/" + (filter || "") + "/"
      // + (latnw || "") + "/" + (lngnw || "")
      // + (latse || "") + "/" + (lngse || "");
      let positionsObserver = this.http.get(
        url,
        {headers: this.headers}
      )
        .map((res:Response) =>
        {
          let body = res.json();
          var data = body || {};

          // AS: распарсим тахографическую инфу
          if(data !== undefined || data != null) {
            for(let d of data) {
              d.tachoSlot1 = TachoData.parse(d.EXT_DATA1);
              d.tachoSlot2 = TachoData.parse(d.EXT_DATA2);
            }
          }
          return data;
        });
        //.catch(this.handleError);

      positionsObserver.subscribe((data) => {
          try {
            this.storage.set('positions', data);
            observer.next(data);
            observer.complete();
            return;
          }catch(err){
            throw Observable.throw(err);
          }
        },
        (err) => {
          console.log(err);

          try {
            this.storage.get('positions')
              .then((data) => {
                observer.next(data);
                observer.complete();
                return;
              })
              .catch(e => {
                console.log(e);
                return Observable.throw(e);
              });
          }
          catch(err){
            throw Observable.throw(err);
          }
        }
      );
    });
  }

  // AS: история. Треки, статистика
  public loadTrack(id: number, f: number, t: number): Observable<any[]>{
    return this.http.get(
      this.objectsUrl + "/track" + "/" + id + '/' + f + '/' + t,
      {headers: this.headers})
      .map((resp:Response) => {
        return this.prepareData(resp);
      });
      //.catch(this.handleError);
  }

  // AS: history info (statistics)
  public loadHistoryStats(id: number, df: number, dt: number): Observable<any>{

    let url = this.objectsUrl + "/" + id + "/historystats/" + df + "/" + dt;

    return this.http.get(url, {headers: this.headers})
      .map(this.prepareData);
      //.catch(this.handleError);
  }

  // AS: history moves/stops
  public loadHistoryMovesStops(id: number, df: number, dt: number): Observable<any>{

    let url = this.objectsUrl + "/" + id + "/history/" + df + "/" + dt;

    return this.http.get(url, {headers: this.headers})
      .map(this.prepareData);
      //.catch(this.handleError);
  }

  // AS: посчитаем и вернем количество рейсов (поездок)
  public tripsCount(data: any[]): Promise<number>{
    return new Promise<number>((resolve, reject) => {
      if(!data){
        return resolve(null);
      }

      let count: number = 0;
      for(let d of data){
        if(d.AVG_SPEED > 0){
          count++;
        }
      }

      return resolve(count);
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/monitoring-object-service.ts